import saas from '@/utils/saas'
import Common from '@/utils/saas/common' // 工具类

// 修改手机号
export function editPhone(data) {
  return Common.createRequest(saas.ServiceName.CUSTOMER_API, 'CUSTOMER_004', data, '修改手机号')
}

// 获取短信验证码
export function getSmsCode(data) {
  return Common.createRequest(saas.ServiceName.DICT_API, 'SEND_SMS', data, '发送短信验证码')
}

// 提交修改密码
export function submitEditPassword(data) {
  return Common.createRequest(saas.ServiceName.CUSTOMER_API, 'customer_update_trade_pwd', data, '修改密码')
}

// 提交设置密码
export function submitSetPassword(data) {
  return Common.createRequest(saas.ServiceName.CUSTOMER_API, 'customer_set_trade_password', data, '设置密码')
}

// 提交设置登录密码接口
export function setLoginPassword(data) {
  return Common.createRequest(saas.ServiceName.CUSTOMER_API, 'customer_set_login_password', data, '设置登录密码')
}

// 提交修改登录密码
export function submitEditLoginPassword(data) {
  return Common.createRequest(saas.ServiceName.CUSTOMER_API, 'customer_update_login_pwd', data, '修改登录密码')
}

// 获取用户名
export function getName(data) {
  return Common.createRequest(saas.ServiceName.CUSTOMER_API, 'CUSTOMER_007', data, '获取用户名')
}

// 找回支付密码提交
export function pwdForget(data) {
  return Common.createRequest(saas.ServiceName.CUSTOMER_API, 'customer_forget_pwd_trade_check', data, '找回支付密码')
}

// 找回登录密码提交
export function pwdLoginForget(data) {
  return Common.createRequest(saas.ServiceName.CUSTOMER_API, 'customer_login_pwd_forgot_check', data, '找回登录密码')
}

// 找回登录密码重置密码
export function pwdLoginForgetReset(data) {
  return Common.createRequest(saas.ServiceName.CUSTOMER_API, 'customer_login_pwd_forgot_and_update', data, '登录密码重置')
}

// 找回支付密码重置密码
export function pwdTradeForgetReset(data) {
  return Common.createRequest(saas.ServiceName.CUSTOMER_API, 'customer_forget_trade_pwd_update', data, '找回支付密码')
}

// 校验短信验证码
export function checkSms(data) {
  return Common.createRequest(saas.ServiceName.DICT_API, 'VERIFY_SMS', data)
}

// 忘记密码
export function pwdForgetLogin(data) {
  return Common.createRequest(saas.ServiceName.CUSTOMER_API, 'customer_login_pwd_forgot', data)
}

// 注销账户
export function customeCancel(data) {
  return Common.createRequest(saas.ServiceName.CUSTOMER_API, 'customer_cancel', data)
}
// 查询个人或企业客户的银行卡
export function searchCipher(data) {
  return Common.createRequest(saas.ServiceName.CUSTOMER_API, 'cipher_search_list', data)
}

// 查询注销审核状态备注
export function queryAuditDetail(data) {
  return Common.createRequest('customer-api', 'CusCancelAuditInfoApi/detailForApp', data)
}

export function queryDetailCustomer(data) {
  return Common.createRequest('customer-api', 'customer/detailCustomer', data)
}
